import { Link } from 'react-router';
import { useTranslation } from 'react-i18next';

import { paths } from 'src/routes/paths';
import { SOCIAL_LINKS } from 'src/config-global';
import { BrandLogo } from 'src/components/brand-logo';
import { serviceNavItems } from 'src/layouts/nav-config';
import { LanguageSelect } from 'src/components/language-select';
import { useConsent } from 'src/components/cookie-consent/consent-context';

const COMPANY_LINKS = [
  { key: 'about', path: paths.about },
  { key: 'contact', path: paths.contact },
  { key: 'privacy', path: paths.privacy },
] as const;

export function SiteFooter() {
  const { t } = useTranslation('footer');
  const { t: tCommon } = useTranslation('common');
  const { t: tConsent } = useTranslation('consent');
  const { openSettings } = useConsent();

  return (
    <footer className="site-footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <Link to={paths.home} className="brand" aria-label={tCommon('brand.homeAriaLabel')}>
              <BrandLogo />
            </Link>
            <p>{t('description')}</p>
            <p className="footer-note">{t('note')}</p>
          </div>
          <div>
            <h4>{t('servicesTitle')}</h4>
            <ul>
              {serviceNavItems.map((item) => (
                <li key={item.key}>
                  <Link to={item.path}>{t(`links.${item.key}`)}</Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4>{t('companyTitle')}</h4>
            <ul>
              {COMPANY_LINKS.map((item) => (
                <li key={item.key}>
                  <Link to={item.path}>{t(`links.${item.key}`)}</Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4>{t('registryTitle')}</h4>
            <ul className="legal-list">
              <li>{t('registry.company')}</li>
              <li>
                {t('registry.street')}
                <br />
                {t('registry.city')}
              </li>
              <li>{t('registry.taxId')}</li>
              <li>{t('registry.identifiers')}</li>
            </ul>
          </div>
        </div>
        <div className="footer-legal">
          <span>{t('copyright', { year: new Date().getFullYear() })}</span>
          <button type="button" onClick={openSettings} className="consent-manage">
            {tConsent('manage')}
          </button>
          <LanguageSelect />
          <span>
            <a target="_blank" rel="noopener noreferrer" href={SOCIAL_LINKS.linkedin}>
              {t('social.linkedin')}
            </a>
            <span>&nbsp;·&nbsp;</span>
            <a target="_blank" rel="noopener noreferrer" href={SOCIAL_LINKS.facebook}>
              {t('social.facebook')}
            </a>
          </span>
        </div>
      </div>
    </footer>
  );
}
